// CV theme palettes — purely color/CSS variables, independent of layout.
// Layouts reference CSS custom properties (--accent, --accent-strong, --bg, --on-accent)
// so any of the 10 themes can be applied to any of the 20 layouts.

export const THEMES = {
  navy:    { name_ar: "كحلي",   name_en: "Navy",   accent: "#1E3A8A", strong: "#172554", soft: "#DBEAFE", on: "#FFFFFF" },
  blue:    { name_ar: "أزرق",   name_en: "Blue",   accent: "#2563EB", strong: "#1D4ED8", soft: "#DBEAFE", on: "#FFFFFF" },
  teal:    { name_ar: "تركواز", name_en: "Teal",   accent: "#0D9488", strong: "#0F766E", soft: "#CCFBF1", on: "#FFFFFF" },
  green:   { name_ar: "أخضر",   name_en: "Green",  accent: "#16A34A", strong: "#15803D", soft: "#DCFCE7", on: "#FFFFFF" },
  purple:  { name_ar: "بنفسجي", name_en: "Purple", accent: "#7C3AED", strong: "#6D28D9", soft: "#EDE9FE", on: "#FFFFFF" },
  red:     { name_ar: "أحمر",   name_en: "Red",    accent: "#DC2626", strong: "#B91C1C", soft: "#FEE2E2", on: "#FFFFFF" },
  orange:  { name_ar: "برتقالي", name_en: "Orange", accent: "#EA580C", strong: "#C2410C", soft: "#FFEDD5", on: "#FFFFFF" },
  gray:    { name_ar: "رمادي",  name_en: "Gray",   accent: "#475569", strong: "#1E293B", soft: "#E2E8F0", on: "#FFFFFF" },
  black:   { name_ar: "أسود",   name_en: "Black",  accent: "#111827", strong: "#000000", soft: "#E5E7EB", on: "#FFFFFF" },
  gold:    { name_ar: "ذهبي",   name_en: "Gold",   accent: "#B45309", strong: "#92400E", soft: "#FEF3C7", on: "#FFFFFF" },
};

export const THEME_LIST = Object.entries(THEMES).map(([slug, t]) => ({ slug, ...t }));

export const themeVars = (slug) => {
  const t = THEMES[slug] || THEMES.navy;
  return {
    "--accent":        t.accent,
    "--accent-strong": t.strong,
    "--accent-soft":   t.soft,
    "--on-accent":     t.on,
  };
};

// Skill display style options.
export const SKILL_STYLES = [
  { slug: "bullets",  name_ar: "قائمة نقاط",     name_en: "Bullets" },
  { slug: "tags",     name_ar: "وسوم",            name_en: "Tags / Chips" },
  { slug: "bars",     name_ar: "أشرطة تقدّم",     name_en: "Progress Bars" },
  { slug: "dots",     name_ar: "نقاط دائرية",     name_en: "Circular Dots" },
  { slug: "percent",  name_ar: "نسبة مئوية",      name_en: "Percentages" },
  { slug: "stars",    name_ar: "نجوم",            name_en: "Stars" },
];

// Photo style options.
export const PHOTO_STYLES = [
  { slug: "none",     name_ar: "بدون صورة",    name_en: "No photo" },
  { slug: "round",    name_ar: "دائرية",        name_en: "Circular" },
  { slug: "square",   name_ar: "مربعة",         name_en: "Square" },
  { slug: "banner",   name_ar: "كبيرة بأعلى",   name_en: "Banner / Top" },
  { slug: "sidebar",  name_ar: "داخل الشريط",   name_en: "In sidebar" },
];
